import { createContext } from 'react';
import type { WorktreeImageResult } from '@shared/agent-protocol';
import type { ApiResponse } from '@/lib/api';

/** SF-T-266: reads a picture from the run's worktree (GET /api/runs/:id/image), for AgentPicture. */
export type PictureReader = (path: string, opts: { signal?: AbortSignal }) => Promise<ApiResponse<{ image: WorktreeImageResult }>>;

/** Where the pictures in a run's messages are read from: AgentActivityFeed provides it. `scope` keys the cache (the run). */
export const AgentPictureContext = createContext<{ read: PictureReader; scope: string } | null>(null);

/** A Markdown image's address the machine can answer: a path on it (not a web address, which isn't fetched). */
export const isMachinePath = (src: string) => src.startsWith('/') || src.startsWith('./');
